<template>
    <span>{{plage}}</span>
</template>

<script>
import moment from "moment";

export default {
    props: {
        a: String,
        d: String
    },
    computed:{
        plage(){
            let a = (Math.round(moment.duration(this.a).asHours()*100)/100).toFixed(2);
            let d = (Math.round(moment.duration(this.d).asHours()*100)/100).toFixed(2);
            //let a = moment(`${moment().format('YYYY-MM-DD')} ${this.a}`);
            //let d = moment(`${moment().format('YYYY-MM-DD')} ${this.d}`);
            if (a === d){
                return "-";
            }else{
                return `${a} - ${d}`;
            }
        }
    }
}
</script>